module.exports = __webpack_public_path__ + "img/55.02b82b60.svg";